import { render, staticRenderFns } from "./BaseIconButtonAdd.vue?vue&type=template&id=4e3be9d4&scoped=true&"
import script from "./BaseIconButtonAdd.vue?vue&type=script&lang=js&"
export * from "./BaseIconButtonAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3be9d4",
  null
  
)

export default component.exports